import { RelatedToType } from '@shared/enums';
import { JupiterStateFeatureSupportModel } from './@store/types';
import { panelLabelMap } from './consts';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { JupiterState } from './@store/state';
import { plural } from 'pluralize';

export const resolveTitle = (titlePart: string): string => {
  const store = inject(Store);
  const relatedObjectLabel = store.selectSnapshot(JupiterState.getRelatedToObject)?.label;
  const contextRelatedObjectLabel = plural(store.selectSnapshot(JupiterState.getContext)?.relatedToObject?.label ?? '');

  if (contextRelatedObjectLabel) {
    return `${contextRelatedObjectLabel}'s ${plural(relatedObjectLabel ?? '')} - ${titlePart}`;
  }

  return `${relatedObjectLabel} - ${titlePart}`;
};

export const getPanels = ({ panels: panelSupport }: JupiterStateFeatureSupportModel): any[] => {
  const panels = [];

  if (panelSupport) {
    panelSupport.comments && panels.push({ type: 'comments', title: panelLabelMap.comments, meta: { fields: [] } });
    panelSupport['crm-table-panel'] &&
      panels.push(
        ...[
          {
            type: 'crm-table-panel',
            title: 'Deals',
            meta: {
              related_to_type: RelatedToType.Project,
              fields: ['id', 'title', 'project_type_id', 'address_string'],
            },
          },
          {
            type: 'crm-table-panel',
            title: 'Properties',
            meta: { related_to_type: RelatedToType.Property, fields: ['id', 'name', 'address_string'] },
          },
          {
            type: 'crm-table-panel',
            title: 'Contacts',
            meta: {
              related_to_type: RelatedToType.Contact,
              fields: ['id', 'email', 'name', 'phone', 'category_name'],
            },
          },
          {
            type: 'crm-table-panel',
            title: 'Loan Quotes',
            meta: { related_to_type: RelatedToType.LoanQuote, fields: ['workflow_state'] },
          },
        ],
      );
    panelSupport.form && panels.push({ type: 'form', title: panelLabelMap.form, meta: { fields: [] } });
    panelSupport.images && panels.push({ type: 'images', title: panelLabelMap.images, meta: { fields: [] } });
    panelSupport.matrix && panels.push({ type: 'matrix', title: panelLabelMap.matrix, meta: { fields: [] } });
    panelSupport.table && panels.push({ type: 'table', title: panelLabelMap.table, meta: { fields: [] } });
  }

  return panels;
};
